<template>
  <div id="app" v-if="showPage">
    <el-container v-loading="pageLoading">
      <el-header class='main-header' v-if="!pageLoading">
        <div class="header-content">
          <div class="header-left">
            <div class="logo">
                <img src="@/assets/logo.png" alt="">
            </div>
            <el-menu class="main_menu" default-active="main" mode="horizontal">
              <el-menu-item index="main" @click="toStore">{{$t('mainPage')}}</el-menu-item>
              <el-menu-item index="agreement" v-if="appConfig.appId == '1019'"  @click="toAgreement">{{ $t('precautions') }}</el-menu-item>
            </el-menu>
          </div>
          <div class="header-right">
            <template v-if="appConfig.appId!='1019'">
              <el-select class="country_select" v-model="currentLang" @change="langChangeHandle">
                <el-option v-if="appConfig.appId=='1018'" :label="$t('russian')" value="ru-RU"></el-option>
                <template v-else>
                  <el-option  :label="$t('simpleChinese')" value="zh-CN"></el-option>
                  <el-option  :label="$t('ulChinese')" value="zh-TW"></el-option>
                  <el-option  :label="$t('english')" value="en-US"></el-option>
                  <el-option  :label="$t('india')" value="id-ID"></el-option>
                  <el-option  :label="$t('thai')" value="th-TH"></el-option>
                </template>
              </el-select>
            </template>
            <el-select class="country_select" v-model="currentCountry" @change="countryChange" v-if="isLogin&&appConfig.appId!='1019'">
              <el-option v-for="item in wRegionData" :key="item.countryId" :label="item.countryName" :value="item.countryId"></el-option>
            </el-select>
            <div class="point-count" v-if="showPoint&&isLogin">
              {{ pointData.userPointData }} {{ $t("rebatePoint") }}
              <el-tooltip class="item" effect="dark" placement="bottom-end">
                <div slot="content">
                  <div v-html="pointRule.usageStatement" class="rebate-tips"></div>
                </div>
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </div>
            <UserProfile :refreshRouter="refreshRouter" :storage="storage" :roleData="roleData" :isLogin="isLogin" @showLogin="dialogVisible=true" @dialogCtrl="dialogCtrl" @setRoleDialog="roleDialogVisible = true" @logout="logout"/>

          </div>
            <!-- <template v-else>
                <el-select class="country_select" v-model="currentLang" @change="langChangeHandle">
                  <el-option :label="$t('korean')" value="ko-KR"></el-option>
                </el-select>
            </template> -->
        </div>
      </el-header>
      <el-main>
        <router-view :showDialog="showDialog" :logoutAll="logout" ref="childRef" v-if="refreshRouter" />
      </el-main>
      <el-footer></el-footer>
    </el-container>

    <el-dialog v-if="wSwitchLoading == 'loaded'" :title="$t('accountLogin')" :visible.sync="dialogVisible" width="300px" class="login_dialog">
      <el-button v-if='wSwitchData.switchInfoList["37"][0].value.webNtLogin == "true"' style="width: 200px; background-color: #d32e26; font-size: 12px;" @click="loginDialogVisible = true; dialogVisible = false" round type="danger">{{$t('NTAccountLogin')}}</el-button>
      <el-button v-if='wSwitchData.switchInfoList["37"][0].value.webCodeLogin == "true"' style="width: 200px; margin-top: 10px; font-size: 12px;" @click="codeDialogVisible = true; dialogVisible = false" round type="primary">{{$t('logCode')}}</el-button>
      <el-button v-if='wSwitchData.switchInfoList["37"][0].value.webVKIDLogin == "true"' style="width: 200px; margin-top: 10px; font-size: 12px;" @click="vkLoginHandle" round type="success">VK</el-button>
      <el-button v-if='wSwitchData.switchInfoList["37"][0].value.webQrScanLogin == "true"' style="width: 200px; margin-top: 10px; font-size: 12px;" @click="qrCodeSetting" round type="danger">{{$t('qrcodeLogin')}}</el-button>
    </el-dialog>

    <el-dialog :visible.sync="loginDialogVisible" width="300px" class="login_dialog">
      <img src="@/assets/logo.png" alt="" slot="title">
      <el-input type="text" v-model="ntAccount" :placeholder="$t('accountInput')" autocomplete="off"></el-input>
      <el-input style="margin-top:10px" type="password" v-model="ntPwd" :placeholder="$t('plzInputPwd')" autocomplete="off"></el-input>
      <el-button style="margin-top:40px; width:250px; background-color: #d32e26;" @click="loginHandle" round type="danger">{{$t('login')}}</el-button>
    </el-dialog>

    <el-dialog :visible.sync="codeDialogVisible" width="300px" class="login_dialog">
      <img src="@/assets/logo.png" alt="" slot="title">
      <el-input type="text" v-model="ntCode" :placeholder="$t('inputLogCode')" autocomplete="off"></el-input>
      <el-button style="margin-top:40px; width:250px; background-color: #d32e26;" @click="codeLoginHandle" round type="danger">{{$t('login')}}</el-button>
    </el-dialog>
    
    <el-dialog :visible.sync="qrcodeDialogVisible" width="300px" class="login_dialog" @close="qrClose">
      <img src="@/assets/logo.png" alt="" slot="title">
      <div class="qrcode" ref="qrcode"></div>
    </el-dialog>

    <el-dialog  :title="$t('roleLogin')" :visible.sync="roleDialogVisible" v-loading="!refreshRouter" :close-on-click-modal="showClose" :show-close="showClose">
      <div class="role_list" v-for="item of roleData" :key="item.acid">
        <span>{{item.roleName}}</span>
        <span v-if="item.serverName">
          <span v-if="appConfig.appId == '1009' && item.areaId == '61'">{{$t('areaId')}}{{$t('asia')}}</span>
          <span v-else-if="appConfig.appId == '1009' && item.areaId == '62'">{{$t('areaId')}}{{$t('americas')}}</span>
          <span v-else-if="appConfig.appId == '1009' && item.areaId == '63'">{{$t('areaId')}}{{$t('europe')}}</span>
          <span v-else-if="appConfig.appId == '1009'">{{$t('areaId')}}{{item.areaId}}</span>
          {{$t('serverName')}}{{item.serverName}}
        </span>
        <el-button @click="roleSelect(item)" type="danger">{{$t('login')}}</el-button>
      </div>
    </el-dialog>
    <RechargeRecordDialog v-if="recordDialogShow" @closeDialog="recordDialogShow=false"/>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import moment from 'moment'
import QRCode from 'qrcode' 
import UserProfile from './components/UserProfile.vue'
import RechargeRecordDialog from './components/RechargeRecordDialog.vue'
export default {
  name: 'app',
  components: {
    UserProfile,
    RechargeRecordDialog
  },
  data(){
      return {
          buyList: false,
          loading: false,
          storage: {},
          dialogVisible: false,
          loginDialogVisible: false,
          qrcodeDialogVisible: false,
          roleDialogVisible: false,
          recordDialogShow: false,
          ntAccount: '',
          ntPwd: '',
          roleData: {},
          refreshRouter: true,
          isLogin: false,
          geneInterval: null,
          currentCountry: '',
          currentLang: 'en-US',
          pageLoading: true,
          roleChangeFlag: false,
          codeDialogVisible: false,
          ntCode: '',
          appConfig: {},
          roleSelectFlag: false,
         routerWhite:[ '/store', '/agreement']
      }
  },
  created(){
  },
  methods:{
      ...mapActions(['getWebRegion', 'getWebAppInfo', 'getNtLogin', 'getWebRoleList', 'getMallLoginStatus',  'getAllGear', 'getGeneCode', 'getGeneInfo', 'getCodeLogin', 'getVKParams', 'getVKCodeLogin', 'getWebSwitch']),
      vkLoginHandle(){
        this.getVKParams()
      },
      langChangeHandle(){
        window.localStorage.setItem('language', this.currentLang)
        window.i18n.locale = this.currentLang
        this.$router.go(0)
      },
      qrClose(){
        clearInterval(this.geneInterval)
      },
      countryChange(data){
        window.localStorage.setItem('countryId', this.currentCountry)
        window.localStorage.setItem('currency', this.wRegionData.filter(val => val.countryId == this.currentCountry)[0].currency)
        this.$router.go(0)
      },
      qrCodeSetting(){
        this.getGeneCode({
          appId: CONFIG.appId,
          language: window.localStorage.getItem('language'),
          type: 2
        })
      },
      toPay(){
        this.$router.push({
          path: '/pay'
        })
      },
      showDialog(){
        this.dialogVisible = true
      },
      loginHandle(){
        this.getNtLogin({
          appId: CONFIG.appId,
          email: this.ntAccount,
          password: this.$md5(this.ntPwd)
        })
      },
      codeLoginHandle(){
        this.getCodeLogin({
          code: this.ntCode,
          appId: CONFIG.appId
        })
      },
      roleSelect(data){
        if(this.roleSelectFlag){
          return false
        }
        this.roleSelectFlag = true
        let roleData = data
        this.getMallLoginStatus({
          appId: CONFIG.appId,
          areaId: roleData.areaId,
          serverId: roleData.serverId,
          roleId: roleData.roleId,
          uniqueId: roleData.acid,
          language: window.localStorage.getItem('language'),
          uid: this.wNtloginData.webOfficeLoginInfo ? this.wNtloginData.webOfficeLoginInfo.uid : this.storage.uid,
          clientPlat: 'web',
          userOrigin: 'web'
        })
        window.localStorage.setItem('storage', JSON.stringify(roleData))
        this.storage = roleData
        this.roleChangeFlag = true
        this.refreshRouter = false
        this.roleDialogVisible = false
      },
     
      dialogCtrl(tag){
        this.recordDialogShow = true
      },
      logout(){
        window.localStorage.setItem('isLogin', false)
        window.localStorage.setItem('roleData', null)
        window.localStorage.setItem('storage', null)
        this.isLogin = false
        this.pageLoading = false
        this.storage = {}
        this.getWebAppInfo({
          appId: CONFIG.appId
        })
        this.$refs.childRef.logout()
      },
      toStore(){
        this.$router.push({
          path: '/store',
          query: {
            from: 'index'
          }
        })
      },
      toAgreement(){
        this.$router.push({
          path: '/agreement',
         
        })
      }
  },
  computed:{
    ...mapGetters(['iapLoading','pointSwitch','uwLoading', "pointData","pointRule",'status', 'wRegionData', 'wRegionLoading', 'wInfoData', 'wInfoLoading', 'wNtloginData', 'wNtloginLoading', 'wLogoutLoading', 'wRoleData', 'wRoleLoading',   'wGoodsData', 'wGoodsLoading', 'allGearData', 'allGearLoading', 'wGeneCodeData', 'wGeneCodeLoading', 'wGeneInfoData', 'wGeneInfoLoading', 'codeLogData', 'codeLogLoading', 'VKParamsData', 'VKPLoading', 'VKCodeLoginData', 'VKCodeLogLoading', 'wSwitchData', 'wSwitchLoading','showPage']),
    formatDate: (val) => {
      return (val) => {
        return moment(val).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    formatStatus: $vm => {
        return val => {
            if(val == '0'){
                return $vm.$t('toBePaid')
            } else if(val == '100'){
                return $vm.$t('tradeSuccess')
            }
        }
    },
     // 显示礼金支付相关内容
     showPoint() {
            if (this.uwLoading === 'loaded') {
                if (typeof this.pointSwitch !== "string") {
                    return this.pointSwitch.ruleSwitch&&this.pointSwitch.ruleSwitch.quantityDisplay?true:false
                }
            }
            return false;
        },
        showClose(){
          if(this.storage&&this.storage.roleId){
            return true
          }
          return false
        }
  },
  watch:{
    iapLoading(val){
      if(val === 'loaded'){
       if(this.status == '10022'){
        this.$alert( this.$t('error10022'), this.$t("errorMsg"),
          {
            showCancelButton: false,
            confirmButtonText: this.$t('sure'),
            center: true
          }
        ).then(() => {
          if(this.roleData.length > 1){
            this.pageLoading = false
            this.refreshRouter = true
            this.roleDialogVisible = true
          }
        })  
          
      }
    }
  }},
  mounted() {
    // 监听storage变化
    window.addEventListener("storage", () => {
      let config=window.localStorage.getItem("storage")
      this.storage =config? JSON.parse(window.localStorage.getItem("storage")):{};
      this.$forceUpdate()
    });
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      if(CONFIG.appId == '1018'){
        window.location.href = "https://mall.newtypegames.com/?lang=ru-RU"
      }
      if(CONFIG.appId == '1019'){
        window.location.href = "https://mall.newtypegames.com/?lang=ko-KR"
      }
      else {
        window.location.href = "https://mall.newtypegames.com"
      }
    }
    if(this.showPage){
      this.appConfig = CONFIG
      this.storage = JSON.parse(window.localStorage.getItem('storage'))
      this.roleData = JSON.parse(window.localStorage.getItem('roleData'))
      if(window.localStorage.getItem('language') && window.localStorage.getItem('language') !== 'undefined'){
        window.i18n.locale = window.localStorage.getItem('language')
        this.currentLang = window.localStorage.getItem('language')
      } else {
        window.localStorage.setItem('language', '')
      }
      if(this.$route.path == '/'){
        this.loading = true
      }
      this.getWebSwitch({
        appId: CONFIG.appId,
        switchId: '37',
        channelId: '15'
      })
      if(window.localStorage.getItem('storage') !== null && window.localStorage.getItem('storage') !== 'null'){
        window.localStorage.setItem('isLogin', true)
        this.isLogin = true
        if(this.$route.path == '/'){
          this.loading = false
          this.$router.push({
            path: '/store',
            query: {
              from: 'index'
            }
          })
        }
        this.getWebRegion({
          appId: CONFIG.appId,
          language: window.localStorage.getItem('language'),
          accessToken: this.storage.accessToken,
        })
        this.getAllGear({
            appId: CONFIG.appId,
            language: window.localStorage.getItem('language'),
        })
      } else {
        if(this.$route.query.verify_code){
          this.getVKCodeLogin({
            code: this.$route.query.verify_code
          })
        } else {
          window.localStorage.setItem('isLogin', false)
          this.isLogin = false
          this.getWebAppInfo({
            appId: CONFIG.appId
          })
        }
      }
    }
    this.$watch('showPage', val => {
      if(val){
        this.appConfig = CONFIG
        this.storage = JSON.parse(window.localStorage.getItem('storage'))
        this.roleData = JSON.parse(window.localStorage.getItem('roleData'))
        if(window.localStorage.getItem('language') && window.localStorage.getItem('language') !== 'undefined'){
          window.i18n.locale = window.localStorage.getItem('language')
          this.currentLang = window.localStorage.getItem('language')
        } else {
          window.localStorage.setItem('language', '')
        }
        if(this.$route.path == '/'){
          this.loading = true
        }
        this.getWebSwitch({
          appId: CONFIG.appId,
          switchId: '37',
          channelId: '15'
        })
        if(window.localStorage.getItem('storage') !== null && window.localStorage.getItem('storage') !== 'null'){
          window.localStorage.setItem('isLogin', true)
          this.isLogin = true
          if(this.$route.path == '/'){
            this.loading = false
            this.$router.push({
              path: '/store',
              query: {
                from: 'index'
              }
            })
          }
          this.getWebRegion({
            appId: CONFIG.appId,
            language: window.localStorage.getItem('language'),
            accessToken: this.storage.accessToken,
          })
          this.getAllGear({
              appId: CONFIG.appId,
              language: window.localStorage.getItem('language'),
          })
        } else {
          if(this.$route.query.verify_code){
            this.getVKCodeLogin({
              code: this.$route.query.verify_code
            })
          } else {
            window.localStorage.setItem('isLogin', false)
            this.isLogin = false
            this.getWebAppInfo({
              appId: CONFIG.appId
            })
          }
        }
      }
    })

    this.$watch('VKPLoading', val => {
      if(val == 'loaded'){
        window.location.href = 'https://id.vk.com/authorize?response_type=code&client_id=' + CONFIG.VKId + '&scope=email%20phone&redirect_uri=' + this.VKParamsData.authorizeValue.redirectUrl + '&state=' + this.VKParamsData.authorizeValue.state + '&code_challenge=' + this.VKParamsData.authorizeValue.codeChallenge + '&code_challenge_method=s256'
      }
    })

    this.$watch('VKCodeLogLoading', val => {
      if(val === 'loaded'){
        if(this.VKCodeLoginData.webLoginInfo && this.VKCodeLoginData.webLoginInfo.uid){
          window.localStorage.setItem('isLogin', true)
          this.isLogin = true
          this.getWebRoleList({
            appId: CONFIG.appId,
            uid: this.VKCodeLoginData.webLoginInfo.uid,
            language: window.localStorage.getItem('language'),
            webAccessToken: this.VKCodeLoginData.webLoginInfo.webAccessToken,
          })
        } else {
          setTimeout(() => {
            if(!this.routerWhite.includes(this.$route.path)){
              this.pageLoading = false
              this.loading = false
              this.$router.push({
                path: '/store',
                query: {
                  from: 'index'
                }
              })
            }
          }, 500)
        }
      }
    })

    this.$watch('codeLogLoading', val => {
      if(val === 'loaded'){
        this.getWebRoleList({
          appId: CONFIG.appId,
          uid: this.codeLogData.webLoginResponse.uid,
          language: window.localStorage.getItem('language'),
          webAccessToken: this.codeLogData.webLoginResponse.webAccessToken,
        })
      }
    })

    this.$watch('wGeneInfoLoading', val => {
      if(val === 'loaded'){
        if(this.wGeneInfoData && this.wGeneInfoData.webOfficeLoginInfo){
          if(this.wGeneInfoData.webOfficeLoginInfo.status == 3){
            clearInterval(this.geneInterval)
            this.qrcodeDialogVisible = false
            this.getWebRoleList({
              appId: CONFIG.appId,
              uid: this.wGeneInfoData.webOfficeLoginInfo.uid,
              language: window.localStorage.getItem('language'),
              webAccessToken: this.wGeneInfoData.webOfficeLoginInfo.webAccessToken,
            })
          } else if(this.wGeneInfoData.webOfficeLoginInfo.status == 2){
            clearInterval(this.geneInterval)
            this.getGeneCode({
              appId: CONFIG.appId,
              language: window.localStorage.getItem('language'),
              type: 2
            })
          }
        }
      }
    })

    this.$watch('wGeneCodeLoading', val => {
      if(val === 'loaded'){
        QRCode.toCanvas(JSON.stringify({
          "uniqueCode": this.wGeneCodeData.uniqueCode,
          "type": 2
        }), {
          width: 200,
          margin: 1
        }, (error, canvas) => {
          this.dialogVisible = false
          this.qrcodeDialogVisible = true;
          if(error){
            console.log(error)
            return false
          }
          this.$nextTick(() => {
            this.$refs.qrcode.innerHTML = ''
            this.$refs.qrcode.appendChild(canvas)
          })
          this.geneInterval = setInterval(() => {
            this.getGeneInfo({
              appId: CONFIG.appId,
              uniqueCode: this.wGeneCodeData.uniqueCode,
              type: 2
            })
          }, 500)
        })
      }
    })

  
    this.$watch('wGoodsLoading', val => {
      if(val === 'loaded'){
        if(this.status == '-4'){
          this.logout()
          return false
        }
        if(!this.roleChangeFlag){
          this.roleData[0].accessToken = this.wGoodsData.loginResp.accessToken
          window.localStorage.setItem('storage', JSON.stringify(this.roleData[0]))
          this.storage = this.roleData[0]
          window.localStorage.setItem('isLogin', true)
        } else {
          this.storage.accessToken = this.wGoodsData.loginResp.accessToken
          window.localStorage.setItem('storage', JSON.stringify(this.storage))
          window.localStorage.setItem('isLogin', true)
        }
        this.getWebRegion({
          appId: CONFIG.appId,
          language: window.localStorage.getItem('language'),
          accessToken: this.storage.accessToken,
        })
        this.$nextTick(() => {
          this.isLogin = true
          this.roleSelectFlag = false
          this.refreshRouter = true
          this.roleChangeFlag = false
        })
      }
    })
    this.$watch('wRoleLoading', val => {
      if(val === 'loaded'){
        if(this.wRoleData.webGameRoleList.length == 0){
          this.$alert(this.$t('error10012'), this.$t('sureAgain'), {
              cancelButtonText: this.$t('cancel'),
              confirmButtonText: this.$t('sure'),
              center: true
          })
          return false
        }
        this.refreshRouter = false
        this.roleData = this.wRoleData.webGameRoleList
        window.localStorage.setItem('roleData', JSON.stringify(this.roleData))
        let uid = ''
        if(this.wNtloginData && this.wNtloginData.webOfficeLoginInfo){
          uid = this.wNtloginData.webOfficeLoginInfo.uid
        } else if(this.wGeneInfoData && this.wGeneInfoData.webOfficeLoginInfo){
          uid = this.wGeneInfoData.webOfficeLoginInfo.uid
        } else if(this.codeLogData && this.codeLogData.webLoginResponse){
          uid = this.codeLogData.webLoginResponse.uid
        }
        if(this.roleData.length <= 1){
          this.getMallLoginStatus({
            appId: CONFIG.appId,
            areaId: this.roleData[0].areaId,
            serverId: this.roleData[0].serverId,
            roleId: this.roleData[0].roleId,
            uniqueId: this.roleData[0].acid,
            language: window.localStorage.getItem('language'),
            uid: uid,
            clientPlat: 'web',
            userOrigin: 'web'
          })
        }
        this.getAllGear({
            appId: CONFIG.appId,
            language: window.localStorage.getItem('language'),
        })
        this.loginDialogVisible = false
        this.codeDialogVisible = false
        if(this.roleData.length > 1){
          this.roleDialogVisible = true
          // 改成弹窗
          this.pageLoading = false
          this.refreshRouter = true
        }
      }
    })
    this.$watch('wNtloginLoading', val => {
      if(val === 'loaded'){
        this.getWebRoleList({
          appId: CONFIG.appId,
          uid: this.wNtloginData.webOfficeLoginInfo.uid,
          language: window.localStorage.getItem('language'),
          webAccessToken: this.wNtloginData.webOfficeLoginInfo.webAccessToken,
        })
      }
    })
    this.$watch('wInfoLoading', val => {
      if(val === 'loaded'){
        if(!window.localStorage.getItem('language') || window.localStorage.getItem('language') === 'undefined'){
          this.currentLang = this.wInfoData.language || 'en-US'
          window.i18n.locale = this.wInfoData.language
          window.localStorage.setItem('language', this.wInfoData.language || 'en-US')
        }
        // window.localStorage.setItem('currency', this.wInfoData.currency)
        setTimeout(() => {
          if(!this.routerWhite.includes(this.$route.path)){
            this.pageLoading = false
            this.loading = false
            this.$router.push({
              path: '/store',
              query: {
                from: 'index'
              }
            })
          }
        }, 500)
        setTimeout(() => {
          this.pageLoading = false
        }, 500)
      }
    })
    this.$watch('wRegionLoading', val => {
      if(val === 'loaded'){
        if(this.status == '-4'){
          this.logout()
          return false
        }
        if(this.wRegionData.length > 0){
          // console.log(this.wRegionData.filter(v => v.countryCode == this.wInfoData.currency))
          if(!window.localStorage.getItem('currency')){
            window.localStorage.setItem('currency', this.wRegionData[0].currency)
          }
          if(!window.localStorage.getItem('countryCode')){
            window.localStorage.setItem('countryCode', this.wRegionData[0].countryCode)
          }
          if(!window.localStorage.getItem('countryId')){
            this.currentCountry = this.wRegionData[0].countryId
            window.localStorage.setItem('countryId', this.wRegionData[0].countryId)
          } else {
            this.currentCountry = parseInt(window.localStorage.getItem('countryId'))
          }
          if(this.$route.path == '/store'){
            this.refreshRouter = false
          }
          setTimeout(() => {
            if(!this.routerWhite.includes(this.$route.path)){
              this.pageLoading = false
              this.loading = false
              this.$router.push({
                path: '/store',
                query: {
                  from: 'index'
                }
              })
            } else {
              this.refreshRouter = true
            }
          }, 500)
          setTimeout(() => {
            this.pageLoading = false
          }, 500)
        }
        // if(this.pcInfoData.loginInfo){
        //   window.i18n.locale = this.pcInfoData.loginInfo.language
        //   window.localStorage.setItem('storage', JSON.stringify(this.pcInfoData.loginInfo))  
        // }
      }
    })
  }
  
}
</script>

<style lang="scss">
  .point-count{
    margin-right: 10px;
    color: white;
  }
.el-dropdown-menu__item.is-disabled{
  pointer-events: inherit;
}

.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
  background-color: transparent;
  color: #606266;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // background: url('./assets/bg.png') 0 0 no-repeat;
  background-size: 100% auto !important;
  width: 100%;
  height: 100vh;
  position: relative;
  left: 0;
  top: 0;
  // top: 50%;
  // margin-top: -441px;
  &::-webkit-scrollbar{
    width: 0 !important;
    height: 0 !important;
    display: none;
  }
  .country_select{
    float: right;
    margin-right: 10px;
    .el-input__inner{
      background-color: transparent;
      border: 0;
      color: #fff;
    }
  }
  .login_dialog{
    .el-dialog{
      border-radius: 10px;
      .el-button+.el-button{
        margin-left: 0;
      }
      .el-input__inner{
        border-top: 0px;
        border-left: 0px;
        border-right: 0px;
        margin-top: 2px;
        border-radius: 0;
      }
      .el-input.is-active .el-input__inner, .el-input__inner:focus{
        border-color: red;
      }
      input:-internal-autofill-selected{
          background-color:transparent !important;
          background-image: none;
      }
      input {  
          background-color:transparent;
          box-shadow: 0 0 0px 1000px white inset;
      }
    }
  }
  .role_list{
    border: 1px solid #ededed;
    width: 80%;
    margin: 0 auto;
    margin-bottom: 5px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 20px;
  }
  .dialog_pop{
      z-index: 11;
      background-color: rgba(0,0,0,0.6);
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
  }
  .dialog{
      max-height: 800px;
      overflow: hidden;
      .el-dialog__body{
        max-height: 620px;
      }
  }
}
.el-dialog__body{
  position: relative;
  overflow-y: scroll;
  &::-webkit-scrollbar{
      width: 0 !important;
      height: 0 !important;
      display: none;
  }
}

.el-header {
    &.main-header {
        background-color: #2e2e2e;
        padding: 15px 20px;
        .header-content{
          display: flex;
          align-items: center;
          justify-content: space-between;
            width: 1200px;
            margin: 0 auto;
            .header-right,.header-left{
                display: flex;
                align-items: center;
            }
        }
    }

    .logo {
        position: relative;
        height: 20px;
        width: 55px;
        margin-top: 5px;
       
        img {
            height: 100%;
        }
    }
   
}
.el-main{
  height: calc(100vh - 120px);
}
.el-footer{
  background-color: #2e2e2e;
  padding: 15px 20px;
}

.main_menu {
    margin-left: 20px;
    // float: left;
    background: transparent;

    &.el-menu--horizontal {
        border-bottom: 0 solid #000;

        &>.el-submenu {
            .el-submenu__title {
                height: 30px;
                line-height: 30px;
                border-bottom: 0px;
                color: #fff;
                font-weight: bold;

                &:hover,
                &:focus {
                    background-color: #E60012;
                    color: #fff;
                }
            }

            &.is-active .el-submenu__title::before {
                content: '';
                position: absolute;
                height: 5px;
                width: 50px;
                left: 50%;
                margin-left: -33px;
                bottom: 0;
                margin-bottom: -15px;
                background-color: #fff;
            }
        }

        &>.el-menu-item {
            height: 30px;
            line-height: 30px;
            border-bottom: 0px;
            color: #fff;
            font-weight: bold;

            &:hover,
            &:focus {
                background-color: #E60012;
                color: #fff;
            }

            &.is-active::before {
                content: '';
                position: absolute;
                height: 1px;
                width: 50px;
                left: 50%;
                margin-left: -25px;
                bottom: 15px;
                margin-bottom: -15px;
                background-color: #d32e26;
                // border-top-left-radius: 3px;
                // border-top-right-radius: 3px;
            }
        }
    }

    .el-submenu__title i {
        color: #fff;
        font-weight: bold;
    }
}

.el-message-box .el-message-box__header .el-message-box__title{
  margin-top: 0;
}
.el-collapse{
  border-top: 0px;
  border-bottom: 0px;
  padding: 10px 50px;
}
.el-collapse-item__wrap{
  background-color: transparent;
  border-bottom: 0;
}
.el-collapse-item__content{
  color: #000;
  line-height: 14px;
  font-size: 12px;
  text-align: left;
  padding: 0 10px;
}
.el-collapse-item{
  &.is-active{
    border: 1px solid #eee;
    border-radius: 5px;
    margin-bottom: 10px;
    .el-collapse-item__header{
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  .el-collapse-item__header{
    background-color: transparent;
    border: 1px solid #eee;
    color: #b9b9b9;
    // height: 100px;
    text-align: left;
    margin-bottom: 10px;
    padding: 0 10px;
    border-radius: 5px;
  }
  .coll_img{
    width: 34px;
    height: 31px;
    background-size: 34px 31px !important;
  }
  .coll_name{
    position: absolute;
    line-height: 20px;
    font-size: 14px;
    color: #000;
    left: 130px;
    max-width: 200px;
    font-weight: bolder;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .coll_time{
    position: absolute;
    left: 330px;
    line-height: 20px;
    font-size: 12px;
  }
  .coll_status{
    position: absolute;
    right: 105px;
  }
}
.el-popover{
    font-size: 20px;
    background: #fff5d4;
}
.el-message-box__btns{
  padding: 5px 50px 0;
  .el-button{
    // background: url('./assets/submit.png') 0 0 no-repeat;
    background-size: 100% 100% !important;
    width: 95px;
    height: 44px;
    border: 0px;
    &:hover{
      color: #606266;
    }
  }
  .el-button--primary{
    color: #606266;
  }
}
body{
  margin: 0;
  background-color: rgba(0,0,0,0.01);
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.el-message-box{
  width: 634px;
  height: 264px;
  position: absolute;
  // background: url('./assets/pop.png') 0 0 no-repeat;
  background-size: 100% auto !important;
  box-shadow: inherit;
  border: 0px;
  left: 50%;
  top: 310px;
  margin-left: -317px;
  text-align: center;
  color: #000;
  .el-message-box__title{
    font-size: 30px;
    line-height: 36px;
    margin-top: 20px;
    color: #000;
  }
  .el-message-box__content{
    font-size: 20px;
    line-height: 36px;
    color: #000;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-content: center;
    height: 100px;
  }
  .el-message-box__headerbtn{
    width: 28px;
    height: 29px;
    top: 20px;
    right: 24px;
    i{
      display: none;
    }
  }
  .el-message-box__btns .el-button{
    width: 200px;
    font-size: 22px;
    margin: 0 20px;
  }
}
</style>
